export default __webpack_public_path__ + "static/media/mobile.e7014989.svg";